import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const FontSizeContext = createContext();

const STORAGE_KEY = 'app-font-scale';
const DEFAULT_SCALE = 1.0;
const MIN_SCALE = 0.75;
const MAX_SCALE = 1.5;
const STEP = 0.05;

export function FontSizeProvider({ children }) {
  const [scale, setScale] = useState(() => {
    const saved = parseFloat(localStorage.getItem(STORAGE_KEY));
    if (Number.isFinite(saved)) return Math.min(MAX_SCALE, Math.max(MIN_SCALE, saved));
    return DEFAULT_SCALE;
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, String(scale));
    const root = document.documentElement;
    root.style.fontSize = `${scale * 16}px`;
  }, [scale]);

  const increase = useCallback(() => {
    setScale(s => Math.min(MAX_SCALE, Math.round((s + STEP) * 100) / 100));
  }, []);

  const decrease = useCallback(() => {
    setScale(s => Math.max(MIN_SCALE, Math.round((s - STEP) * 100) / 100));
  }, []);

  const reset = useCallback(() => {
    setScale(DEFAULT_SCALE);
  }, []);

  return (
    <FontSizeContext.Provider value={{ scale, increase, decrease, reset, minScale: MIN_SCALE, maxScale: MAX_SCALE }}>
      {children}
    </FontSizeContext.Provider>
  );
}

export function useFontSize() {
  const ctx = useContext(FontSizeContext);
  if (!ctx) {
    return { scale: 1.0, increase: () => {}, decrease: () => {}, reset: () => {}, minScale: MIN_SCALE, maxScale: MAX_SCALE };
  }
  return ctx;
}
